import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'

import * as CategoriaService from 'services/categoria.service'
import * as Modals from './modals'

import { ZrSwal } from 'utils'

const portletBreadcrumbs = [{ name: 'Categorias' }]

const tableHeaderRows = [
  {
    label: 'NOMBRE',
    filter: {
      type: 'text',
      name: 'nom'
    }
  },
  { label: '', width: 40 }
]

const ListaPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)
  const editarDataRef = React.useRef({})

  const [mostrarNuevaCategoriaModal, setMostrarNuevaCategoriaModal] = React.useState(false)

  const clickNuevo = React.useCallback(() => {
    editarDataRef.current = {}
    setMostrarNuevaCategoriaModal(true)
  }, [])

  const clickEditar = React.useCallback(
    id => {
      CategoriaService.obtenerxIdAsEdicion(id)
        .then(({ data }) => {
          editarDataRef.current = data
          setMostrarNuevaCategoriaModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        mensaje: 'Seguro que deasea eliminar el registro?',
        showCerrar: true,
        tipo: 'error',
        onSuccess: () => {
          CategoriaService.eliminarxId(id)
            .then(() => {
              __zariContext.toast('success', 'Registro eliminado.')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <>
      <>
        <Portlet>
          <Portlet.Header
            title='Categorias'
            breadcrumbs={portletBreadcrumbs}
            buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
          />
          <Portlet.Body>
            <Table.ServerSide
              ref={tablaRef}
              useNest={true}
              useFilters={true}
              url='/categorias'
              headRows={tableHeaderRows}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar(row._id)}>
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='eliminar'
                          handleClose={handleClose}
                          onClick={e => clickEliminar(row._id)}
                        >
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      </>
      {mostrarNuevaCategoriaModal && (
        <Modals.NuevoActualizarModal
          show={mostrarNuevaCategoriaModal}
          handleClose={() => setMostrarNuevaCategoriaModal(false)}
          editarData={editarDataRef.current}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default ListaPage
